import React from 'react';
import { LoginPage } from '@repo/common';
import { IS_LEGACY_DOMAIN } from '../../utils/brand.js';

const AUTH_BRAND = IS_LEGACY_DOMAIN ? 'oing' : 'koready';

const Login = () => <LoginPage brand={AUTH_BRAND} />;

export default Login;
